module.exports = __webpack_public_path__ + "img/suitcase.0e319a03.svg";